module.exports = __webpack_public_path__ + "img/mobileOutlineGray.b454d46.svg";